import { Dropdown } from "@/crud/form/Dropdown";
import { TicketAllocation } from "@/models/accreditation";
import { getIn, useFormikContext } from "formik";

interface TicketDropdownProps {
  name: string;
  // the tickets allocated to the group
  tickets: Array<TicketAllocation>;
  // the count and IDs of the ones already selected
  ticketCount: Record<number, number>;
  hideBorder?: boolean;
}

export const TicketAllocationDropdown = ({
  name,
  tickets,
  ticketCount,
  hideBorder,
}: TicketDropdownProps) => {
  const { values } = useFormikContext();

  // Get the currently selected tickets for the individual
  const selectedTickets = getIn(values, name) || [];

  // Calculate available tickets
  const availableTickets = tickets
    .map((t) => {
      const pickedCount = ticketCount[t.ticket.id] || 0; // already excludes self
      const availableQuantity = t.quantity - pickedCount;
      return {
        id: t.ticket.id,
        value: t.ticket.name,
        availableQuantity,
      };
    })
    // keep options that still have quantity OR are already selected
    .filter(
      (opt) =>
        opt.availableQuantity > 0 ||
        selectedTickets.some((sel: any) => sel.id === opt.id)
    );

  // Include the currently selected tickets in the available options
  const options = availableTickets.map((t) => ({ id: t.id, value: t.value }));

  return (
    <Dropdown
      name={name}
      options={options}
      hideBorder={hideBorder}
      multiple
      isUpdating
      hideError
    />
  );
};
